import _ from 'lodash'
import { Map, List, fromJS } from 'immutable'
import { iCollectElementsParentHash, iFixElementChildren } from './project-structure-utils'

export const processUpdateFormFieldStyles = (inState) => {
  let state = inState

  try {
    let projElements = state.getIn(['project', 'Settings', 'elements'], Map())
    const elementsParentHash = iCollectElementsParentHash(projElements)
    _.each(elementsParentHash, (parentList, elemID) => {
      const elem = projElements.get(elemID, Map())
      const fixedElem = iFixElementChildren(elem, parentList)
      projElements = projElements.set(elemID, fixedElem)
    })
    state = state.setIn(['project', 'Settings', 'elements'], projElements)

    state = state.set(
      'pages',
      state.get('pages', Map()).map((inPage, pageId) => {
        let pageElements = inPage.getIn(['Props', 'elements'], Map())
        const elementsParentHash = iCollectElementsParentHash(pageElements)
        _.each(elementsParentHash, (parentList, elemID) => {
          const elem = pageElements.get(elemID, Map())
          const fixedElem = iFixElementChildren(elem, parentList)
          inPage = inPage.setIn(['Props', 'elements', elemID], fixedElem)
        })
        return inPage
      })
    )
  } catch (error) {
    console.error(error)
  }

  const projectStyleRef = {}
  state.getIn(['project', 'Settings', 'elements'], Map()).map((elem) => {
    if (['FormField', 'Search', 'AddressFinder', 'ExternalLookup'].indexOf(elem.get('type')) !== -1) {
      let ref = elem.getIn(['props', 'styleRef'])
      projectStyleRef[ref] = projectStyleRef[ref] || []
      projectStyleRef[ref].push(
        elem.get('type') === 'Search'
          ? 'search'
          : ['AddressFinder', 'ExternalLookup'].indexOf(elem.get('type')) !== -1
            ? _.camelCase(elem.get('type'))
            : elem.getIn(['props', 'control'], 'text')
      )
    }
  })

  let globalStyles = {}
  _.each(projectStyleRef, (additionalControls, ref) => {
    state = state.setIn(
      ['project', 'Settings', 'styles', ref, 'additionalControls'],
      fromJS(_.compact(_.uniq(additionalControls)))
    )
    if (state.getIn(['project', 'Settings', 'styles', ref, 'isGlobal'])) {
      globalStyles[ref] = _.compact(_.uniq(additionalControls))
    }
  })

  state = state.set(
    'pages',
    state.get('pages', Map()).map((inPage) => {
      let styles = {}
      let page = inPage
      page.getIn(['Props', 'elements'], Map()).map((elem) => {
        if (['FormField', 'Search', 'AddressFinder', 'ExternalLookup'].indexOf(elem.get('type')) !== -1) {
          let ref = elem.getIn(['props', 'styleRef'])
          if (state.getIn(['project', 'Settings', 'styles', ref, 'isGlobal'])) {
            globalStyles[ref] = globalStyles[ref] || []
            globalStyles[ref].push(
              elem.get('type') === 'Search'
                ? 'search'
                : ['AddressFinder', 'ExternalLookup'].indexOf(elem.get('type')) !== -1
                  ? _.camelCase(elem.get('type'))
                  : elem.getIn(['props', 'control'], 'text')
            )
          } else {
            styles[ref] = styles[ref] || []
            styles[ref].push(
              elem.get('type') === 'Search'
                ? 'search'
                : ['AddressFinder', 'ExternalLookup'].indexOf(elem.get('type')) !== -1
                  ? _.camelCase(elem.get('type'))
                  : elem.getIn(['props', 'control'], 'text')
            )
          }
        }
      })
      _.each(styles, (additionalControls, ref) => {
        page = page.setIn(['Props', 'styles', ref, 'additionalControls'], fromJS(_.compact(_.uniq(additionalControls))))
      })

      try {
        let localStyles = page.getIn(['Props', 'styles'], Map()).toJS()
        _.each(localStyles, function (style, ref) {
          if (style && ref && state.getIn(['project', 'Settings', 'styles', ref, 'isGlobal'], false)) {
            delete localStyles[ref]
          }
        })
        page = page.setIn(['Props', 'styles'], fromJS(localStyles))
      } catch (err) {
        console.error(err)
      }
      return page
    })
  )

  _.each(globalStyles, (additionalControls, ref) => {
    state = state.setIn(
      ['project', 'Settings', 'styles', ref, 'additionalControls'],
      fromJS(_.compact(_.uniq(additionalControls)))
    )
  })

  return state
}
